<template>
  <!-- <a
    :href="src"
    target="_blank"
    class="image-container"
    :class="{ inline: inline }"
    :style="{ width: width, height: height }"
  >
    <img :src="src" />
  </a> -->

  <el-image
    :src="src"
    :preview-src-list="[...src]"
  >
  </el-image>
</template>

<script>
export default {
  name: "ImageWrapper",
  props: {
    src: String,
    inline: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "100px",
    },
    height: {
      type: String,
      default: "100px",
    },
  },
};
</script>

<style lang="less" scoped>
@import url("~styles/variables.less");

.image-container {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  width: 100px;
  height: 100px;
  border: 1px solid @border-color-base;
  border-radius: 4px;
  padding: 10px;
  background-color: #fff;

  &.inline {
    display: inline-flex;
    align-self: flex-start;
    vertical-align: top;
    margin: 0 10px 10px 0;
  }

  img {
    max-height: 100%;
    max-width: 100%;
  }
}
</style>
